import { FuncArr, _setErrorDispatcher } from './func_arr';
import { globalOptions } from './global_options';
import { dumpSingleElementToString } from './node';
import { isComponent } from './type_symbol';
let insideErrorHandler = false;
const errorFuncArr = new FuncArr('error');
const warningFuncArr = new FuncArr('warning');
_setErrorDispatcher(dispatchError);
export function dispatchError(err, method, relatedComponent, element) {
    if (!insideErrorHandler) {
        insideErrorHandler = true;
        if (isComponent(relatedComponent)) {
            relatedComponent.triggerLifetime('error', [err]);
        }
        const shouldBreak = errorFuncArr.call(err, [err, method, relatedComponent, element]) === false;
        insideErrorHandler = false;
        if (shouldBreak)
            return;
    }
    if (globalOptions.throwGlobalError) {
        throw err;
    }
    else {
        // eslint-disable-next-line no-console
        console.error([
            err instanceof Error ? `${err.message}` : String(err),
            element ? `\t@${dumpSingleElementToString(element)}` : undefined,
            relatedComponent
                ? `\t${method || ''}@${typeof relatedComponent === 'string'
                    ? `<${relatedComponent}>`
                    : dumpSingleElementToString(relatedComponent || false)}`
                : undefined,
        ]
            .filter(Boolean)
            .join('\n'));
    }
}
export function triggerWarning(msg, relatedComponent, element) {
    if (warningFuncArr.call(null, [msg, relatedComponent || '', element])) {
        // eslint-disable-next-line no-console
        console.warn(msg);
    }
}
export class ThirdError extends Error {
    constructor(message, additionalStack, relatedComponent, element) {
        super(message);
        this.additionalStack = additionalStack;
        this.relatedComponent = relatedComponent;
        this.element = element;
        dispatchError(this, additionalStack, relatedComponent, element);
    }
}
export function addGlobalErrorListener(func) {
    errorFuncArr.add(func);
}
export function removeGlobalErrorListener(func) {
    errorFuncArr.remove(func);
}
export function addGlobalWarningListener(func) {
    warningFuncArr.add(func);
}
export function removeGlobalWarningListener(func) {
    warningFuncArr.remove(func);
}
export function safeCallback(type, method, caller, args, relatedComponent) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return method.apply(caller, args);
    }
    catch (e) {
        dispatchError(e, `${type || 'Listener'} ${method.name || '(anonymous)'}`, relatedComponent);
        return undefined;
    }
}
//# sourceMappingURL=warning.js.map